import {styled} from "@mui/material";

export const CenteredCircularProgressContainer =  styled('div')`
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
`